import * as bootstrap from 'bootstrap';
import { renderAttachPreview } from './utilities';
import { setPageNumber } from './paging';
export function getAlbumImagesData(pageSize, pageNumber, isPageChange) {
    var _a;
    const placeHolder = document.getElementById('PostAlbumsListPlaceholder');
    const list = document.querySelector('.AlbumsList');
    const yafUserId = placeHolder.dataset.userid || '0';
    const ajaxUrl = '/api/Album/GetAlbumImages';
    const pagedResults = {
        UserId: parseInt(yafUserId),
        PageSize: pageSize,
        PageNumber: pageNumber,
    };
    fetch(ajaxUrl, {
        method: 'POST',
        body: JSON.stringify(pagedResults),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=utf-8',
            'RequestVerificationToken': ((_a = document.querySelector('input[name="__RequestVerificationToken"]')) === null || _a === void 0 ? void 0 : _a.value) || '',
        },
    })
        .then((res) => res.json())
        .then((data) => {
        list.innerHTML = '';
        document.getElementById('PostAlbumsLoader').style.display = 'none';
        data.attachmentList.forEach((dataItem) => {
            const li = document.createElement('div');
            li.classList.add('col-6', 'col-sm-4', 'p-1');
            li.style.cursor = 'pointer';
            li.setAttribute('onclick', dataItem.onClick);
            li.innerHTML = dataItem.iconImage;
            list.appendChild(li);
        });
        renderAttachPreview('.attachments-preview');
        setPageNumber(pageSize, pageNumber, data.totalRecords, document.getElementById('AlbumsListPager'), 'Album Images', 'getAlbumImagesData');
        if (isPageChange && document.querySelector('.albums-toggle') !== null) {
            const toggleBtn = document.querySelector('.albums-toggle');
            const dropdownEl = new bootstrap.Dropdown(toggleBtn);
            dropdownEl.toggle();
        }
    })
        .catch((error) => {
        console.error(error);
        document.getElementById('PostAlbumsLoader').style.display = 'none';
        placeHolder.textContent = error.message;
    });
}
const _global = (window /* browser */ || global /* node */);
_global.getAlbumImagesData = getAlbumImagesData;
